import { InputBlock } from '@coast/schemas';
import { isEmpty } from 'lodash';
import React, { useContext } from 'react';
import { View } from '@shared/components/View';
import { MBLoadingIndicator } from '@shared/components/loading';
import { MBDefaultError } from '@shared/components/wrapper';
import { ColorThemeContext, grid } from '@shared/styles';
import { MBBlockLabel } from '../../utils/label';
import { useSignatureFieldHooks } from './hooks/SignatureFieldHooks';
import { SignatureView } from './signature/';
import { SignatureBlockData } from './signature/SignatureProps';

interface Props {
  block: InputBlock;
}

export function SignatureInputBlock({ block }: Props) {
  const colors = useContext(ColorThemeContext);
  const height = grid(10);
  const { signatureUrl, uploadSignature, clearSignature, isLoading, error } =
    useSignatureFieldHooks(block);

  function setDataUrl(url: string) {
    if (isEmpty(url)) {
      clearSignature();
    } else {
      uploadSignature(url, 'signature.png');
    }
  }

  return (
    <>
      {block?.label && (
        <View paddingLeft={3} paddingVertical={1}>
          <MBBlockLabel label={block.label} />
        </View>
      )}
      {(isLoading || !isEmpty(error)) && (
        <View
          flex
          center
          style={{
            height,
            borderRadius: grid(1),
            borderStyle: 'dashed',
            borderWidth: 2,
            backgroundColor: colors.input.backgroundInactive,

            borderColor: isEmpty(signatureUrl)
              ? colors.input.borderInactive
              : colors.input.borderActive,
          }}
          marginHorizontal={1}
        >
          {isLoading && <MBLoadingIndicator />}
          {!isEmpty(error) && <MBDefaultError message={error} />}
        </View>
      )}
      {!isLoading && (
        <SignatureView
          onSignatureUpdate={url => setDataUrl(url)}
          height={height}
          block={block as SignatureBlockData}
          signatureUrl={signatureUrl}
          marginHorizontal={grid(1)}
        />
      )}
    </>
  );
}
